// Google Tag Manager Integration for SmartFacture AI
// GTM allows managing all tracking tags from a single container

const GTM_ID = process.env.REACT_APP_GTM_ID;

// Initialize GTM
export function initializeGTM() {
  if (!GTM_ID) {
    console.warn('GTM ID not configured');
    return;
  }

  // Check if already initialized
  if (window.gtmInitialized) return;
  window.gtmInitialized = true;

  // GTM Script
  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', GTM_ID);

  console.log('GTM initialized:', GTM_ID);
}

// Push events to dataLayer (GTM will handle them)
export function pushEvent(eventName, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...params
  });
}

// Track page view
export function trackPageView(path, title) {
  pushEvent('page_view', {
    page_path: path,
    page_title: title || document.title
  });
}

// Pre-defined event trackers for SmartFacture AI
export const analytics = {
  // User authentication events
  trackSignup: (method = 'email') => {
    pushEvent('sign_up', { method });
  },

  trackLogin: (method = 'email') => {
    pushEvent('login', { method });
  },

  // Subscription events
  trackSubscriptionStart: (plan, value) => {
    pushEvent('purchase', {
      currency: 'EUR',
      value: value,
      plan_name: plan
    });
  },

  trackTrialStart: (plan) => {
    pushEvent('trial_start', { plan_name: plan });
  },

  // Funnel events
  trackPricingView: () => {
    pushEvent('view_pricing');
  },

  trackCheckoutBegin: (plan, price) => {
    pushEvent('begin_checkout', {
      currency: 'EUR',
      value: price,
      plan_name: plan
    });
  },

  // Feature engagement
  trackFeatureUse: (featureName) => {
    pushEvent('feature_use', { feature_name: featureName });
  },

  trackInvoiceCreated: () => {
    pushEvent('invoice_created');
  },

  trackInvoiceScanned: () => {
    pushEvent('invoice_scanned');
  },

  trackExportGenerated: (exportType) => {
    pushEvent('export_generated', { export_type: exportType });
  },

  // Guide/Lead events
  trackGuideDownload: () => {
    pushEvent('generate_lead', { lead_type: 'guide_download' });
  },

  // Button clicks
  trackButtonClick: (buttonName, section) => {
    pushEvent('button_click', { button_name: buttonName, section });
  },

  // Demo engagement
  trackDemoView: () => {
    pushEvent('demo_view');
  },

  // Blog engagement
  trackBlogView: (articleSlug, articleTitle) => {
    pushEvent('blog_article_view', { article_slug: articleSlug, article_title: articleTitle });
  },

  // Partner program
  trackPartnerSignup: () => {
    pushEvent('partner_signup');
  }
};

export default { initializeGTM, trackPageView, pushEvent, analytics };
